import { useUser } from '@/hooks/use-user';

export const JIMMY_EMAIL = 'jimmy.truong@evercars.com';
const RANDY_EMAIL = 'randy.duong@evercars.com';
export const TJ_EMAIL = 'tj@evercars.com';
export const LASSE_EMAIL = 'lasse@evercars.com';
export const MAX_EMAIL = 'max@evercars.com';
export const ARJUN_EMAIL = 'arjun.mitra@evercars.com';

const ENGINEER_EMAILS = [
  JIMMY_EMAIL,
  TJ_EMAIL,
  'hannah.truong@evercars.com',
  RANDY_EMAIL,
  'daniel.hegeman@evercars.com',
  'arjun.mitra@evercars.com',
  'forlefac.fontem@evercars.com',
  'marko.jovanovic@evercars.com',
  'jared.williams@evercars.com',
  // NOT ACTUALLY ENGINEERS, but are testing this feature in early access
  'andrew.lambrecht@evercars.com',
  'jon.rueckner@evercars.com',
];

const FINANCE_MANAGER_EMAILS = [
  'danielle.kolczak@evercars.com',
  'trevor.brown@evercars.com',
  'janet.kim@evercars.com',
  'oscar.villasenor@evercars.com',
];

const GENERAL_MANAGER_EMAILS = ['troy.johnson@evercars.com', 'stefan.aubertin@evercars.com'];

const SALES_MANAGER_EMAILS = [
  'yevgeniy.slissenko@evercars.com',
  'giorgi.kobiashvili@evercars.com',
  'nicholas.mills@evercars.com',
  'robert.hannigan@evercars.com',
];

const LOGISTICS_MANAGER_EMAILS = ['danielle.bleier@evercars.com'];

const PADDOCK_EMAILS = ['paddock@evercars.com'];

const FOUNDER_EMAILS = [TJ_EMAIL, LASSE_EMAIL, MAX_EMAIL];

const CONTRACTOR_EMAILS = ['gt@evercars.com'];

const OPS_EMAILS = ['daniel.carrillo@evercars.com'];

const BUSINESS_OFFICE_EMAILS = [
  'candy.tovar@evercars.com',
  'sam.abdel@evercars.com',
  'antonio.valega@evercars.com',
];

const CONTROLLER_EMAIL = 'thomas.pepper@evercars.com';

const BDC_EMAILS = [
  'mercury.piscitello@evercars.com',
  'taressa.svarda@evercars.com',
];

const BUYER_EMAILS = ['chris.robinson@evercars.com'];

export const useIsEngineer = (): {
  isEngineer: boolean;
  isJimmy: boolean;
  isTJ: boolean;
  isArjun: boolean;
  isRandy: boolean;
} => {
  const user = useUser();

  const isEngineer = ENGINEER_EMAILS.includes(user.email);
  const isJimmy = user.email === JIMMY_EMAIL;
  const isTJ = user.email === TJ_EMAIL;
  const isArjun = user.email === ARJUN_EMAIL;
  const isRandy = user.email === RANDY_EMAIL;

  return { isEngineer, isJimmy, isTJ, isArjun, isRandy };
};

export const useIsFounder = (): {
  isFounder: boolean;
  isLasse: boolean;
} => {
  const user = useUser();

  const isFounder = FOUNDER_EMAILS.includes(user.email);
  const isLasse = user.email === LASSE_EMAIL;

  return { isFounder, isLasse };
};

export const useIsFinanceManager = (): {
  isFinanceManager: boolean;
} => {
  const user = useUser();

  const isFinanceManager = FINANCE_MANAGER_EMAILS.includes(user.email);

  return { isFinanceManager };
};

export const useIsGeneralManager = (): {
  isGeneralManager: boolean;
} => {
  const user = useUser();

  const isGeneralManager = GENERAL_MANAGER_EMAILS.includes(user.email);

  return { isGeneralManager };
};

export const useIsPaddockUser = ({
  email,
}: {
  email?: string;
}): {
  isPaddockUser: boolean;
} => {
  const user = useUser();

  const isPaddockUser = PADDOCK_EMAILS.includes(email || user.email);

  return { isPaddockUser };
};

export const useIsManager = (): {
  isManager: boolean;
} => {
  const user = useUser();
  const isManager =
    SALES_MANAGER_EMAILS.includes(user.email) ||
    GENERAL_MANAGER_EMAILS.includes(user.email) ||
    FINANCE_MANAGER_EMAILS.includes(user.email);

  return { isManager };
};

export const useIsSalesManager = (): {
  isSalesManager: boolean;
} => {
  const user = useUser();
  const isSalesManager = SALES_MANAGER_EMAILS.includes(user.email);
  return { isSalesManager };
};

export const useIsContractor = (): {
  isContractor: boolean;
} => {
  const user = useUser();
  const isContractor = CONTRACTOR_EMAILS.includes(user.email);
  return { isContractor };
};

export const useIsOps = (): {
  isOps: boolean;
} => {
  const user = useUser();
  const isOps = OPS_EMAILS.includes(user.email);
  return { isOps };
};

export const useIsBusinessOffice = (): {
  isBusinessOffice: boolean;
} => {
  const user = useUser();
  const isBusinessOffice = BUSINESS_OFFICE_EMAILS.includes(user.email);
  return { isBusinessOffice };
};

export const useIsController = (): {
  isController: boolean;
} => {
  const user = useUser();
  const isController = user.email === CONTROLLER_EMAIL;
  return { isController };
};

export const useIsBDC = (): {
  isBDC: boolean;
} => {
  const user = useUser();
  const isBDC = BDC_EMAILS.includes(user.email);
  return { isBDC };
};

export const useIsBuyer = (): {
  isBuyer: boolean;
} => {
  const user = useUser();
  const isBuyer = BUYER_EMAILS.includes(user.email);
  return { isBuyer };
};

export const useIsLogisticsManager = (): {
  isLogisticsManager: boolean;
} => {
  const user = useUser();
  const isLogisticsManager = LOGISTICS_MANAGER_EMAILS.includes(user.email);
  return { isLogisticsManager };
};